/**
 * @description 查詢公告資料 公告類別(type) 參數用
 */
export enum BulletinType {
  Default = '0',
  InsType = '1'
}
